import MealRatingBadge from 'components/core/menu/MealRatingBadge'

import { RATING_PER_STAR } from './utils'
import RatingOnboardingIllustration from './RatingOnboardingIllustration'

const RatingOnboardingSubmittedCard = ({ rating }: { rating: number }) => {
  return (
    <div className="px-4 pb-10 pt-4 text-center">
      <div className="flex h-[347px] w-full items-center justify-center rounded-[10px] bg-grey-1">
        <div className="relative">
          <RatingOnboardingIllustration />
          <div className="absolute -top-1 left-[14px]">
            <MealRatingBadge stars={rating / RATING_PER_STAR} />
          </div>
        </div>
      </div>

      <h2 className="mt-6 text-k/24_120">
        Personalize your menu based on your ratings.
      </h2>
      <p className="mt-3 text-k/20_110 text-grey-10">
        When your favorites are on the menu, we&apos;ll let you know!
      </p>
    </div>
  )
}

export default RatingOnboardingSubmittedCard
